import { getToken } from 'firebase/messaging';
import { messaging } from './firebase';

export const requestPermission = async () => {
  const permission = await Notification.requestPermission();

  if (permission === 'granted') {
    const token = await getToken(messaging, {
      vapidKey:
        'BDaHEBw7ivQ4BFPN7e2hQBtY6O26S3muqpQ5CHU43gKTd9RKT9je2ghNq1x2qZPkfY0TRK4w2L4pQGnGHy7ImcM',
    });
    console.log('FCM Token Generate');
    return token;
  } else {
    console.log('Notification Permission Denied');
  }
};
